import * as React from "react";
import { IoCloseSharp } from "react-icons/io5";
import Styled from "./styled";
import EmptyCartImg from "@assets/img/empty-cart-image.png";
import { useNavigate } from "react-router";
import "./index.css";

const EmptyCart: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Styled.RootContainer>
      <Styled.HeaderContainer>
        <Styled.HeaderCloseButtonContainer
          onClick={() => {
            if (window.history.state && window.history.state.idx > 0) {
              navigate(-1);
            } else {
              navigate("/", { replace: true });
            }
          }}
        >
          <IoCloseSharp size={26} color={"black"} />
        </Styled.HeaderCloseButtonContainer>
        <Styled.HeaderTitle>Sacola</Styled.HeaderTitle>
      </Styled.HeaderContainer>
      <Styled.SummaryContainer className="my-5">
        <img src={EmptyCartImg} className="empty-cart-image" alt="empty-cart" />
      </Styled.SummaryContainer>
      <Styled.HeaderTitle style={{ fontSize: 28 }}>Sacola vazia...</Styled.HeaderTitle>
      <p className="px-4 pt-3 text-muted" style={{ fontSize: 16 }}>
        {" "}
        Adicione produtos no carrinho para continuar com o seu pedido
      </p>
      <p className="pb-3 px-4 "> Para dar uma olhada no que temos para você, basta clicar no botão a seguir </p>
      <a href={`/`}>
        <Styled.BackToStoreButton>Voltar à loja</Styled.BackToStoreButton>
      </a>
    </Styled.RootContainer>
  );
};

export default EmptyCart;
